export default {
  backend: process.env.BACKEND_URL || "http://utas.vostro.loc:7097/",
  portal: process.env.PORTAL_URL || "/portal",
  authEndpoint: process.env.AUTH_ENDPOINT || "/check-login.json",
  auth: process.env.AUTH_URL || "",
  externalUrl: process.env.EXTERNAL_URL || "https://www.utas.edu.au/",
  sentryDSN: process.env.SENTRY_DSN || ""
}